import React, { Component } from 'react';

//componentes
import CxCNuevo from './cxcNuevo'

class Index extends Component {

    render(){
        return(
            <div>
                <CxCNuevo />
            </div>
        );
    }

}
export default Index;